import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { AppDispatch as Dispatch, AppState, AppListenerEntry as ListenerEntry } from '@/redux/create-store';

export type AppListenerEntry = ListenerEntry;
export type AppDispatch = Dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
